
import React from "react";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { CartItem as CartItemType } from "@/types/product";
import { useLanguage } from '@/contexts/LanguageContext';

interface CartItemProps {
  item: CartItemType;
  removeFromCart: (productId: string) => void;
}

const CartItem: React.FC<CartItemProps> = ({ item, removeFromCart }) => {
  const { t } = useLanguage();
  const totalPoints = item.product.pointsPrice * item.quantity;
  
  return (
    <div className="flex items-center space-x-4 py-4 border-b border-gray-700">
      <div className="flex-shrink-0 w-16 h-16 bg-white rounded overflow-hidden">
        <img
          src={item.product.image}
          alt={item.product.name}
          className="w-full h-full object-contain"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = "/lovable-uploads/60244da3-6deb-4628-b29a-c8e90866808e.png"; // Imagem default
          }}
        />
      </div>
      
      <div className="flex-1">
        <h4 className="text-sm font-medium text-white">{item.product.name}</h4>
        <p className="text-xs text-gray-400">{t('products.quantity')}: {item.quantity}</p>
        <div className="flex justify-between items-center mt-1">
          <span className="text-sm text-brand-red font-medium">{totalPoints} storepoints</span>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 text-gray-400 hover:text-brand-red"
            onClick={() => removeFromCart(item.productId)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
